var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingLightning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.019 1.70989C11.4044 1.83139 11.6665 2.18884 11.6665 2.59298V7.22257L15.3702 7.22257C15.7154 7.22257 16.032 7.41466 16.1915 7.72089C16.3509 8.02712 16.3267 8.39663 16.1287 8.67947L9.64731 17.9387C9.41555 18.2697 8.99584 18.4123 8.6104 18.2908C8.22496 18.1693 7.96285 17.8118 7.96285 17.4077L7.96285 12.7781H4.25917C3.91392 12.7781 3.59734 12.586 3.4379 12.2798C3.27846 11.9735 3.30264 11.604 3.50063 11.3212L9.98206 2.062C10.2138 1.73092 10.6335 1.5884 11.019 1.70989Z",
    fill: "#F08E0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingLightning);
export default __webpack_public_path__ + "static/media/onboarding-lightning.e7f39c5c6efd7f5fc7895b21bf009e03.svg";
export { ForwardRef as ReactComponent };